import { render, staticRenderFns } from "./LineChatMessage.vue?vue&type=template&id=751d52c8&"
import script from "./LineChatMessage.vue?vue&type=script&lang=js&"
export * from "./LineChatMessage.vue?vue&type=script&lang=js&"
import style0 from "./LineChatMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports